// extracted by mini-css-extract-plugin
export default {"root":"ktNYre","visuallyHidden":"CAUsXL","empty":"vc3z33","link":"n_3BBP"};